import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    // 1. User State
    const [user, setUser] = useState({
        name: 'Guest User',
        balance: 150000,
        isVerified: false,
        onboarded: false
    });

    // 2. Bookings State
    const [bookings, setBookings] = useState([
        { id: 101, type: 'Telemedicine', provider: 'Dr. Adewale K. Solomon', time: 'Today, 2:30 PM', status: 'Confirmed', amount: 5000 },
        { id: 102, type: 'Private Tutor', provider: 'Mr. John Obi', time: 'Feb 19, 4:00 PM', status: 'Pending', amount: 3000 },
    ]);

    // 3. Transactions List
    const [transactions, setTransactions] = useState([]);

    // Persist onboarding status
    useEffect(() => {
        const onboarded = localStorage.getItem('ez_onboarded');
        if (onboarded) setUser(prev => ({ ...prev, onboarded: true }));
    }, []);

    // Helper: Add a new booking
    const addBooking = (newBooking) => {
        setBookings(prev => [newBooking, ...prev]);
        // Deduct from balance
        setUser(prev => ({ ...prev, balance: prev.balance - newBooking.amount }));
        // Log transaction
        setTransactions(prev => [{
            id: Date.now(),
            type: 'Debit',
            category: newBooking.type,
            amount: newBooking.amount,
            date: new Date().toISOString()
        }, ...prev]);
    };

    // Helper: Update Wallet Balance
    const updateBalance = (amount) => {
        setUser(prev => ({ ...prev, balance: prev.balance + amount }));
    };

    // Helper: Set Verification Status (Admin Action)
    const setVerified = (status) => {
        setUser(prev => ({ ...prev, isVerified: status }));
    };

    return (
        <AppContext.Provider value={{ 
            user, 
            setUser, 
            bookings, 
            addBooking, 
            transactions, 
            updateBalance, 
            setVerified 
        }}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => useContext(AppContext);
